import _ from 'lodash'
import EventBus from '@/helpers/eventBus'
import mixinAlerta from '@/mixins/alerta'

export default {
  mixins: [mixinAlerta],
  data () {
    return {
      permiso: '',
      listado: {
        mostrar: false,
        referencia: 'abmListado'
      },
      formulario: {
        mostrar: false,
        item: {},
        operacion: null,
        titulo: 'Editar'
      },
      modalAccion: this.masterModalAccion(),
      montarMixin: true
    }
  },
  mounted () {
    if (this.montarMixin) {
      this.listado.mostrar = true
      this.formulario.mostrar = false
      this.filtrarListado()
    }
  },
  methods: {
    puedo (operacion) {
      return this.$puedo(this.permiso + ':' + operacion)
    },
    puedoPermiso (permiso, operacion) {
      return this.$puedo(permiso + ':' + operacion)
    },
    crear () {
      this.formulario = _.assign(this.formulario, {
        operacion: 'alta',
        titulo: 'Crear',
        item: {
          id: 0
        },
        mostrar: true
      })
    },
    editar (item) {
      this.formulario = _.assign(this.formulario, {
        operacion: 'modif',
        titulo: 'Modificar',
        item: item,
        mostrar: true
      })
    },
    ver (item) {
      this.formulario = _.assign(this.formulario, {
        operacion: 'lectura',
        titulo: 'Ver',
        item: item,
        mostrar: true
      })
    },
    ejecutarAlGuardar (item) {},
    alGuardar (item) {
      this.ejecutarAlGuardar(item)
      this.filtrarListado()
      this.alCerrar()
    },
    alCerrar () {
      this.formulario.mostrar = false
    },
    filtrarListado () {
      this.ocultarAlerta()
      EventBus.$emit(this.listado.referencia + ':filtrar')
    },
    masterModalAccion () {
      return {
        mostrar: false,
        ancho: '100%',
        componente: null,
        item: {},
        operacion: null,
        titulo: 'Detalle',
        alGuardar: this.alGuardar
      }
    }
  }
}
